import gsap from "gsap";
import { ScrollTrigger, SplitText } from "gsap/src/all";

export const dimensions = {
    scrollBarWidth: 16,
};

export const aniClosePrompt = () => {
    const wrapper = document.getElementById("prompt-wrapper");
    const wrapperBox = wrapper?.getBoundingClientRect();

    gsap.to("#prompt-input", { top: 12 });
    gsap.to("#prompt-container", {
        height: "94px",
        top: wrapperBox?.top,
    }).then(() => {
        gsap.set("#prompt-container", {
            position: "relative",
            zIndex: undefined,
            top: 0,
        });
        gsap.set("body", { overflow: "auto", paddingRight: 0 });
    });
};

export const aniOpenPrompt = () => {
    const wrapper = document.getElementById("prompt-wrapper");
    const wrapperBox = wrapper?.getBoundingClientRect();
    gsap.set("#prompt-container", {
        position: "fixed",
        top: wrapperBox?.top,
        height: wrapperBox?.height,
        zIndex: 50,
    });

    gsap.to("#prompt-container", { height: "100vh", top: 0 });
    gsap.to("#prompt-input", { top: 190 });

    gsap.set("body", {
        overflow: "hidden",
        paddingRight: dimensions.scrollBarWidth,
    }).then(() => {
        window.scrollTo({ top: 0, behavior: "instant" });
    });
};

export const aniCompletePrompt = () => {
    gsap.from("#proposals", { opacity: 0, y: 60, duration: 0.6 });
    gsap.fromTo(
        "#hero .root",
        { opacity: 0, y: 220, duration: 0.6 },
        { opacity: 1, y: 140 }
    );
    gsap.to(["#prompt-container"], {
        height: "680px",
    }).then(() => {
        console.log("Enough data to allow scrolling");

        //Setup Scroll animation are 80% view
        const tl = gsap.timeline({ paused: true });
        tl.to(
            "#prompt-container",
            { height: "84px", duration: 1, ease: "linear" },
            0
        );

        tl.to(".logo", { opacity: 0, duration: 0.25 }, 0.5);
        tl.to(
            "#font-size",
            { scale: 0.5, y: "-267px", duration: 1, ease: "linear" },
            0
        );
        tl.to(
            "#red-wrap",
            { y: "-208px", height: "60px", duration: 1, ease: "linear" },
            0
        );
        tl.to(
            "#hero .root",
            { scale: 1, y: 0, duration: 1, ease: "linear" },
            0
        );
        // tl.to("#red-wrap", {  duration: 0.7, ease: "none" }, 0);

        tl.to(
            ["#underline", "#response", "#prompt-caption"],
            { opacity: 0, duration: 0.2, y: "-40px", ease: "linear" },
            0
        );
        tl.to(
            "#proposals",
            { opacity: 0, y: -40, duration: 0.5, ease: "linear" },
            0.1
        );

        ScrollTrigger.create({
            animation: tl,
            trigger: "#prompt-wrapper",
            start: "top 0x",
            end: "+=560px",
            pin: true,
            pinSpacing: false,
            scrub: 0.2,
            // markers: true,
            onLeave: function () {
                gsap.set("#prompt-wrapper", { clearProps: "transform" });
            },
        });

        gsap.set("body", { overflow: "auto", paddingRight: 0 });

        const handleClick = () => {
            window.scrollTo({ top: 0, behavior: "smooth" });
        };
        const promptWrapper = document.getElementById("prompt-wrapper");
        promptWrapper?.addEventListener("click", handleClick);
    });
};

export const aniResponseText = () => {
    gsap.set("#response", { opacity: 0 });
    const responseText = new SplitText("#response", { type: "words" });
    gsap.fromTo(
        responseText.words,
        { opacity: 0 },
        { opacity: 1, stagger: 0.05 }
    );
    gsap.set("#response", { opacity: 1 });
};
